import { useCurrentUser } from "@/hooks/use-current-user";
import { useEffect, useState } from "react";
import { getUserBasicQuotaTrainsCount } from "@/actions/db/train-voices";
import { getUserLicense } from "@/actions/db/get-user-license";
import { LicenseName } from "@/data/license.data";
import { customVoiceLicenseManager } from "@/services/license/license-managers/custom-voices-license-manager";

export const useOutOfVoices = () => {
  const user = useCurrentUser();
  const [maxCustomVoicesCount, setMaxCustomVoicesCount] = useState<number>(0);
  const [remainingVoicesCount, setRemainingVoicesCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    (async (user) => {
      if (!user || !user.id) {
        return;
      }

      const userLicense = (await getUserLicense(user.id)) as LicenseName;
      const userCustomVoices = await getUserBasicQuotaTrainsCount(user.id);

      let maxCountVoices =
        await customVoiceLicenseManager.serviceUsingCountLimiter.getLimit(
          user.id,
          userLicense,
        );
      if (maxCountVoices === Infinity) {
        setMaxCustomVoicesCount(9999);
        maxCountVoices = 9999;
      }

      setMaxCustomVoicesCount(maxCountVoices);
      let outOfVoices = maxCountVoices - userCustomVoices;
      if (outOfVoices < 0) {
        outOfVoices = 0;
      }
      setRemainingVoicesCount(outOfVoices);
    })(user).then(() => setIsLoading(false));
  }, []);

  return {
    isLoading,
    remainingVoicesCount,
    maxCustomVoicesCount,
  };
};
